import { render, staticRenderFns } from "./LoginBRC.vue?vue&type=template&id=7f53eaa4&"
import script from "./LoginBRC.vue?vue&type=script&lang=js&"
export * from "./LoginBRC.vue?vue&type=script&lang=js&"
import style0 from "./LoginBRC.vue?vue&type=style&index=0&id=7f53eaa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports